export default __webpack_public_path__ + "static/media/darkArrow.2c63b9ad.svg";